import { render, staticRenderFns } from "./Envelopamento.vue?vue&type=template&id=fa9fcffc"
import script from "./Envelopamento.vue?vue&type=script&lang=js"
export * from "./Envelopamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports